// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9509) return "static/chunks/6f31d389-adaba45f3d43f19c.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1805":"25f4ac2a","9777":"recorder"}[chunkId] || chunkId) + "." + {"1805":"30dc3b0963889998","3112":"4f184c4414b87004","6532":"d6f5cc4e3138deb3","6824":"884c19939fd336ed","8436":"cab94b59cca0a8ff","8499":"06992243b3bd8bb3","9777":"4c15194f16637940"}[chunkId] + ".js";
};